// extracted by mini-css-extract-plugin
export var attribution = "_cg-4";
export var authorName = "_cg-5";
export var quote = "_cg-3";
export var testimonial = "_cg-2";
export var trustedBy = "_cg-0";
export var trustedByLabel = "_cg-1";